(() => {
  // Checkout applies the free-shipping threshold of the delivery country, while each host renders the threshold of its
  // own market (localization.country). A Belgian on nl. or an Irish visitor on the English root therefore gets the
  // threshold of the country Shopify detects for them, when that country has one.
  const dataElement = document.getElementById('fs-free-shipping-data');
  if (!dataElement) return;
  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch {
    return;
  }
  const countries = data.countries || {};
  const format = (value) => data.format.replace('[n]', value);
  const storageKey = 'fs-detected-country';

  const apply = (country) => {
    const value = countries[country];
    if (value == null) return;
    document.querySelectorAll('[data-fs-free-shipping-template]').forEach((element) => {
      element.textContent = element.dataset.fsFreeShippingTemplate.replace('[amount]', format(value));
    });
    document.querySelectorAll('[data-fs-free-shipping-table] tr[data-fs-free-shipping-country]').forEach((row) => {
      if (row.dataset.fsFreeShippingCountry === country) row.setAttribute('aria-current', 'true');
      else row.removeAttribute('aria-current');
    });
  };

  const detected = () => {
    try {
      const cached = sessionStorage.getItem(storageKey);
      if (cached !== null) return Promise.resolve(cached);
    } catch {}
    return fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : {}))
      .then((json) => {
        const country = json?.detected_values?.country?.handle || '';
        try {
          sessionStorage.setItem(storageKey, country);
        } catch {}
        return country;
      })
      .catch(() => '');
  };

  detected().then((country) => {
    if (country && country !== data.market) apply(country);
  });

  document.querySelectorAll('[data-fs-shipping-country]').forEach((select) => {
    select.addEventListener('change', () => {
      if (countries[select.value] != null) apply(select.value);
    });
  });
})();
